import Vue from 'vue';

const state = {
    isDownloadingOldGroups: false,
    availabilityTypes: [
        {
            label: 'Unlimited',
            value: 1,
        },
        {
            label: 'Fixed limit',
            value: 0,
        },
        {
            label: 'Limited by resources',
            value: 2,
        },
    ],
    extraTicketInfo: [
        {
            id: 1,
            name: 'ticketNotFullyPaid',
            label: 'Ticket is not fully paid',
            text: null,
        },
        {
            id: 2,
            name: 'ticketFullyPaid',
            label: 'Ticket is fully paid',
            text: null,
        },
    ],
    productShedulesWithReservations: [],
    isResquestingProductSchedulesRestrictions: false
};

const getters = {
    getAvailabilityTypes: (state) => state.availabilityTypes,
    getIsDownloadingOldGroups: (state) => state.isDownloadingOldGroups,
    getExtraTicketInfo: (state) => state.extraTicketInfo,
    getProductSchedulesRestrictions: (state) => state.productShedulesWithReservations,
    getIsRequestingProductSchedulesRestrictions: (state) => state.productShedulesWithReservations
};

const actions = {
    resetProductSchedulesRestrictions({commit}) {
        commit('RESET_PRODUCT_SCHEDULES_RESTRICTIONS');
    },

    requestProductSchedulesRestrictions: ({ state, commit }, prodId) => {
        state.isResquestingProductSchedulesRestrictions = true;
        
        return axios.get(`/api/inventory/restrictions?productId=${prodId}`).then(response => {
            state.isResquestingProductSchedulesRestrictions = false;

            if (response.status === 200) {
                commit('SET_PRODUCT_SCHEDULES_RESTRICTIONS', response.data.restrictions[0]);
            }
        }).catch(err => {
            state.isResquestingProductSchedulesRestrictions = false;
            
            return err;
        })
    },

    getOldGroups: ({state, commit, rootState}, payload) => {
        if(!payload || !payload.reservationId){
            return []
        }

        state.isDownloadingOldGroups = true
        return axios.get('/api/inventory/GetOldProductSchedulesById', {params: {
            supplierId: rootState.user.account.supplierId,
            productId: payload.reservationId,
        }}).then(response => {
            state.isDownloadingOldGroups = false
            let oldGroups = response.data
            oldGroups.map(oldGroup => {oldGroup.backupGroup = JSON.parse(JSON.stringify(oldGroup))})

            oldGroups.map(group => {
                if(group.schedules[0]){
                    group.dateFrom = group.schedules[0].dateFrom? group.schedules[0].dateFrom : group.dateFrom
                    group.dateTo = group.schedules[0].dateTo? group.schedules[0].dateTo : group.dateTo
                    group.duration = group.schedules[0].duration? group.schedules[0].duration : group.duration
                }
                group.backupGroup = JSON.parse(JSON.stringify(group))
            })

            return oldGroups
        }).catch(err => {
            state.isDownloadingOldGroups = false
            return response
        })

    },

    duplicateProduct: ({state, rootState}, payload) => {
        return axios.post('/api/inventory/duplicateProduct', {
            supplierId: rootState.user.account.supplierId,
            product: payload.product,
        }).then(response => {
            if(response.status && response.status == 200){
                return response.data
            } else {
                return false
            }
        }).catch(error => {
            return false
        })
    }
};

const mutations = {
    SET_PRODUCT_SCHEDULES_RESTRICTIONS: (state, data) => {
        state.productShedulesWithReservations = data;
    },

    RESET_PRODUCT_SCHEDULES_RESTRICTIONS: (state, data) => {
        state.productShedulesWithReservations = [];
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js